import React from "react";
import PropTypes from "prop-types";
import has from "lodash/has";
import get from "lodash/get";
import EnhancedSelect from "common/components/EnhancedSelect";
import { MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

const EventInput = ({ option, values, touched, errors, handleChange }) => {
  const { t } = useTranslation();

  return (
    <EnhancedSelect
      id="eventType"
      name="eventType"
      label={t("offer_create.type_option_event")}
      fullWidth
      value={values.custom_values.eventType}
      onChange={(e) => {
        handleChange({
          eventType: e.target.value,
        });
      }}
      error={get(touched, "eventType") && has(errors, "eventType")}
      helperText={
        touched.eventType && has(errors, "eventType")
          ? errors.eventType
          : t("offer_create.basic_event_hint")
      }
    >
      {option.optionValues.map((value) => (
        <MenuItem value={value.value} key={value.value}>
          {value.name}
        </MenuItem>
      ))}
    </EnhancedSelect>
  );
};

EventInput.propTypes = {
  option: PropTypes.shape({
    optionName: PropTypes.string.isRequired,
    optionValues: PropTypes.array.isRequired,
  }).isRequired,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};

export default EventInput;
